interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: 'left' | 'center';
}

export default function SectionHeading({ eyebrow, title, desc, align = 'left' }: SectionHeadingProps) {
  return (
    <div className={`${align === 'center' ? 'text-center mx-auto max-w-2xl' : 'max-w-2xl'}`}>
      {eyebrow && (
        <span className="inline-flex items-center gap-1.5 text-xs md:text-sm font-medium text-primary-600 bg-primary-100 px-3 py-1 rounded-full mb-3">
          <i className="ri-fire-line"></i>
          {eyebrow}
        </span>
      )}
      <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 leading-tight">{title}</h2>
      {desc && <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">{desc}</p>}
    </div>
  );
}